import * as React from 'react';

import {TemplateRCDataFromRequest} from 'core/RateConfirmation/types';
import {getTransformDataToTemplate} from 'core/RateConfirmation/modules/transformDataToTemplate';

import styles from './styles.module.scss';

type OwnProps = {
    data: TemplateRCDataFromRequest;
    withWarn: boolean;
};

const Requirements: React.FC<OwnProps> = ({data, withWarn}) => {
    const {
        requirements: {serviceRequirements, payment, titleWarning},
    } = getTransformDataToTemplate(data);

    const serviceRequirementsList = serviceRequirements.requirementsNote.map((item, index) => (
        <React.Fragment key={index}>
            {item}
            <br />
        </React.Fragment>
    ));
    const paymentList = payment.paymentNote.map((item, index) => (
        <React.Fragment key={index}>
            {item}
            <br />
        </React.Fragment>
    ));

    return (
        <div className={styles.requirements}>
            {withWarn ? <div className={styles.warning}>{titleWarning}</div> : null}
            <h3>{serviceRequirements.title}</h3>
            <p>{serviceRequirementsList}</p>
            <h3>{payment.title}</h3>
            <p>{paymentList}</p>
        </div>
    );
};

export default Requirements;
